import { baseURL, useGetQuery } from "api/config";

const API = {
  BRANCHES: `${baseURL}/api/branches`,
};

export const useGetBranches = () => useGetQuery("BRANCHES", API.BRANCHES);
